import {
  invoicingUpdateData,
  invoicingGetData,
  invoicingCheckGetYwyData
} from '@/api/api'

import {
  dateOperating
} from '@/cllib/tools'

let initCheckProcessStepList = function () {
  return [{
    step: 'check_stock',
    label: '液位仪',
    checked: false,
    checkStep: 0
  },
  {
    step: 'check_start_inventory',
    label: '期初库存',
    checked: false,
    checkStep: 0
  },
  {
    step: 'check_end_inventory',
    label: '期末库存',
    checked: false,
    checkStep: 0
  },
  {
    step: 'check_in_volume',
    label: '入库量',
    checked: false,
    checkStep: 0
  },
  {
    step: 'check_out_volume',
    label: '出库量',
    checked: false,
    checkStep: 0
  },
  {
    step: 'check_result',
    label: '完成',
    checked: false
  }]
}

const state = {
  checkInvoicingData: null,
  checkProcessStepList: initCheckProcessStepList(),
  currentCheckProcessStep: null,
  checkStockResult: null,
  checkInvoicingYwyData: {
    startInventory: null,
    endInventory: null,
    inVolume: null,
    outVolume: null
  }
}

const getters = {
  checkInvoicingData: state => state.checkInvoicingData,
  checkProcessStepList: state => state.checkProcessStepList,
  currentCheckProcessStep: state => state.currentCheckProcessStep,
  checkStockResult: state => state.checkStockResult,
  checkInvoicingYwyData: state => state.checkInvoicingYwyData
}

const actions = {
  checkInvoicingUpdateInvoiving ({ dispatch }, parm) {
    parm.nowErrorVolume = (parseInt(parm.startInventory) || 0) + (parseInt(parm.inVolume) || 0) - (parseInt(parm.outVolume) || 0) - (parseInt(parm.endInventory) || 0) - (parseInt(parm.gainLose) || 0)
    return invoicingUpdateData(parm).then(() => {
      dispatch('getCheckInvoicingData')
    })
  },
  getCheckInvoicingData ({ dispatch, getters }) {
    let parm = {
      noPage: 1,
      id: getters.checkInvoicingData.id
    }
    invoicingGetData(parm).then((data) => {
      data.forEach((item) => {
        item.outVolume = parseInt(item.outVolume)
        item['oilTypeJ'] = item.oilType ? (item.oilType.split('号')[0] + '#') : ''
        item.collectTimeJ = item.collectTime ? item.collectTime.slice(5, 16) : '--'
      })
      let newData = data.length === 1 ? data[0] : {}
      dispatch('setCheckInvoicingData', newData)
    })
  },
  getCheckInvoicingYwyData ({ dispatch, getters }) {
    let parm = {
      gasTankId: getters.checkInvoicingData.gasTankId,
      date: getters.checkInvoicingData.collectTime.slice(0, 10)
    }
    invoicingCheckGetYwyData(parm).then((data) => {
      let newData = {
        startInventory: data.startInventory,
        endInventory: data.endInventory,
        inVolume: data.inVolume,
        outVolume: data.outVolume
      }
      dispatch('setCheckInvoicingYwyData', newData)
    })
  },
  setCheckInvoicingYwyData ({ commit }, data) {
    commit('setCheckInvoicingYwyData', data)
  },
  initCheckProcess ({ commit }) {
    commit('initCheckProcess')
  },
  setCheckInvoicingData ({ commit }, data) {
    if (data && data.collectTime) {
      data['startTime'] = dateOperating.computeDay({days: -1, date: data.collectTime, format: 'yy-mm-dd hh:mm'})
    }
    commit('setCheckInvoicingData', data)
  },
  setCheckStockResult ({ commit, dispatch }, data) {
    commit('setCheckStockResult', data)
    if (data === 'ok') {
      dispatch('getCheckInvoicingYwyData')
    } else {
      let newData = {
        startInventory: null,
        endInventory: null,
        inVolume: null,
        outVolume: null
      }
      dispatch('setCheckInvoicingYwyData', newData)
    }
  },
  goNextCheckStep ({ commit, dispatch, getters }) {
    let currentIndex = 0
    getters.checkProcessStepList.forEach((item, index) => {
      if (item.step === getters.currentCheckProcessStep) {
        currentIndex = index + 1
      }
    })
    if (currentIndex < getters.checkProcessStepList.length) {
      dispatch('setCurrentCheckProcessStep', getters.checkProcessStepList[currentIndex].step)
    }
  },
  setCurrentCheckProcessStep ({ commit, dispatch }, data) {
    commit('setCurrentCheckProcessStep', data)
    dispatch('updateCheckProcessStepList', {step: data, key: 'checked', value: true})
  },
  updateCheckProcessStepList ({ commit }, data) {
    commit('updateCheckProcessStepList', data)
  }
}

const mutations = {
  initCheckProcess (state, data) {
    state.checkProcessStepList = initCheckProcessStepList()
    state.currentCheckProcessStep = null
  },
  setCheckInvoicingYwyData (state, data) {
    state.checkInvoicingYwyData = data
  },
  setCheckInvoicingData (state, data) {
    state.checkInvoicingData = data
  },
  setCheckStockResult (state, data) {
    state.checkStockResult = data
  },
  setCurrentCheckProcessStep (state, data) {
    state.currentCheckProcessStep = data
  },
  updateCheckProcessStepList (state, {step, key, value}) {
    state.checkProcessStepList.forEach((item) => {
      if (item.step === step) {
        item[key] = value
      }
    })
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/weixin/invoicing_check_process/check_process.js